import { render } from '@xingternal/hops';

import App from './PagesApplication';

export default render(App);
